/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import { Grid } from 'semantic-ui-react';
import { UniversalLink } from '@plone/volto/components';
import { VariationWrapper, ImageListing } from 'iovisit-theme/components';

const LinkInEvidence = (data) => {
  const { items, isEditMode } = data;

  return (
    <VariationWrapper {...data} variation="link-in-evidence">
      <Grid stackable centered>
        {items.map((item, index) => {
          return (
            <Grid.Column
              tablet={6}
              computer={3}
              widescreen={3}
              largeScreen={3}
              key={index}
            >
              <div className="link-wrapper">
                <UniversalLink
                  item={!isEditMode ? item : null}
                  href={isEditMode ? '#' : ''}
                  className="img-link"
                >
                  <ImageListing item={item} />
                </UniversalLink>
              </div>
            </Grid.Column>
          );
        })}
      </Grid>
    </VariationWrapper>
  );
};

export default LinkInEvidence;
